import { CoordinatesType as ApiCoordinatesType } from 'src/api/generated/touring/types';
import { CoordinatesType } from '../../types';

export const mapCoordinates = (
  coordinates: ApiCoordinatesType
): CoordinatesType => {
  return {
    latitude: coordinates.latitude,
    longitude: coordinates.longitude,
  };
};

